import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/charge_stations',
  component: Management,
  redirect: '/charge_stations/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/charge_stations/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listChargeStations
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/charge_stations/ListTable'),
          meta: {
            auth: Auth.listChargeStations,
            tabName: 'all'
          }
        },
        {
          path: 'public_dc',
          component: () => import('@/views/charge_stations/ListTable'),
          meta: {
            auth: Auth.listChargeStations,
            tabName: 'public_dc'
          }
        },
        {
          path: 'public_ac',
          component: () => import('@/views/charge_stations/ListTable'),
          meta: {
            auth: Auth.listChargeStations,
            tabName: 'public_ac'
          }
        },
        {
          path: 'private',
          component: () => import('@/views/charge_stations/ListTable'),
          meta: {
            auth: Auth.listChargeStations,
            tabName: 'private'
          }
        },
        {
          path: 'closed',
          component: () => import('@/views/charge_stations/ListTable'),
          meta: {
            auth: Auth.listChargeStations,
            tabName: 'closed'
          }
        }
      ]
    },
    // 地图
    {
      path: 'map',
      component: () => import('@/views/charge_stations/Map'),
      meta: {
        auth: Auth.listChargeStations
      }
    },
    // 新增
    {
      path: 'new',
      component: () => import('@/views/charge_stations/New'),
      meta: {
        auth: Auth.createChargeStation
      }
    },
    // 编辑
    {
      path: ':id/edit',
      component: () => import('@/views/charge_stations/Edit'),
      meta: {
        auth: Auth.updateChargeStation
      }
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/charge_stations/DetailLayout'),
      meta: {
        auth: Auth.showChargeStation
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/charge_stations/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showChargeStation
          }
        },
        // 路书
        {
          path: 'roadbook',
          component: () => import('@/views/charge_stations/details/RoadBook'),
          meta: {
            tabName: 'roadbook', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showChargeStation
          }
        },
        // 充电桩
        {
          path: 'charge_points',
          component: () => import('@/views/charge_stations/details/ChargePoints'),
          meta: {
            tabName: 'charge_points', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.listChargersOfChargeStation
          }
        },
        // 批量修改属性
        {
          path: 'chargers_modify',
          component: () => import('@/views/charge_stations/details/Modify'),
          name: 'chargers_modify',
          meta: {
            tabName: 'chargers', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showChargeStation
          }
        },
        // 批量修改桩、枪属性
        {
          path: 'batch_modify',
          component: () => import('@/views/charge_stations/details/BatchModify'),
          name: 'batch_modify',
          meta: {
            tabName: 'chargePoints', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showChargeStation
          }
        },
        // 状态
        {
          path: 'status_history',
          component: () => import('@/views/charge_stations/details/StatusHistory'),
          meta: {
            tabName: 'status_history', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.listChargeStatusesOfChargeStation
          }
        },
        // 订单
        {
          path: 'orders',
          component: () => import('@/views/charge_stations/details/Orders'),
          meta: {
            tabName: 'orders', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.listOrdersOfChargeStation
          }
        },
        // 订单统计
        {
          path: 'order_statistics',
          component: () => import('@/views/charge_stations/details/OrderStatistics'),
          meta: {
            tabName: 'order_statistics', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showOrderStatisticsOfChargeStation
          }
        },
        // 工单
        {
          path: 'work_orders',
          component: () => import('@/views/charge_stations/details/WorkOrders'),
          meta: {
            tabName: 'work_orders', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showChargeStation
          }
        },
        // 费率
        {
          path: 'billing_rules',
          component: () => import('@/views/charge_stations/details/BillingRules'),
          meta: {
            tabName: 'billing_rules', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showChargeStation
          }
        },
        // 报警
        {
          path: 'alarms',
          component: () => import('@/views/charge_stations/details/Alarms'),
          meta: {
            tabName: 'alarms', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.listAlarmsOfChargeStation
          }
        },
        // 视频监控
        {
          path: 'video_monitoring',
          component: () => import('@/views/charge_stations/details/VideoMonitoring'),
          meta: {
            tabName: 'video_monitoring', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.listNvrChannelsOfChargeStation
          }
        },
        // 地锁
        {
          path: 'parking_locks',
          component: () => import('@/views/charge_stations/details/ParkingLocks'),
          meta: {
            tabName: 'parking_locks', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.listParkingLocksOfChargeStation
          }
        },
        // 停车减免记录
        {
          path: 'parking_relief_records',
          component: () => import('@/views/charge_stations/details/ParkingReliefRecords'),
          meta: {
            tabName: 'parking_relief_records', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.listParkingReliefRecords
          }
        },
        // 数据版本日志
        {
          path: 'model_version_log_audits',
          component: () => import('@/views/charge_stations/details/ModelVersionLogAudits'),
          meta: {
            tabName: 'model_version_log_audits', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.listModelVersionLogAuditsOfChargeStation
          }
        },
        // 用户访问日志
        {
          path: 'station_activities',
          component: () => import('@/views/charge_stations/details/StationActivities'),
          meta: {
            tabName: 'activities', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.listStationActivitiesOfChargeStation
          }
        },
        // 优惠
        {
          path: 'discounts',
          component: () => import('@/views/charge_stations/details/Discounts'),
          meta: {
            tabName: 'discounts', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showChargeStation
          }
        },
        // 结算记录
        {
          path: 'settlements',
          component: () => import('@/views/charge_stations/details/Settlements'),
          meta: {
            tabName: 'settlements', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showChargeStation
          }
        }
      ]
    }
  ]
}
